import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useState } from 'react';
import { ACTION_COMMANDS_EVENT_TYPE, ACTION_COMMANDS_FEATURE_GROUP, ACTION_COMMANDS_TYPE } from '../../../api/ActionCommandsInterface/constants';
import { casinoIdStatus as PlayerStatus } from '../../../api/PlayerInfoConstants';
import { EVENT_EMITTER_TYPE, REQUEST_QUERY_STATUS } from '../../../constants';
import { shallowEqual, useSelector } from '../../../node_modules/react-redux';
import screens from '../../../screens';
import Emitter from '../../../services/EmitterService';
import { useGetDailyWheelDataQuery, useLazyGetDailyWheelBonusQuery } from '../../../state/query/dailyWheel';
import audio from '../../../utils/audio';
import { getLoginStreakList } from '../utils';
import useWheelLogHandler from './useWheelLogHandler';
export default function useGetDailyBonusData(_ref) {
  var dismissModal = _ref.dismissModal;

  var _useGetDailyWheelData = useGetDailyWheelDataQuery(),
      dailyWheelData = _useGetDailyWheelData.data,
      isError = _useGetDailyWheelData.isError,
      dailyWheelDataStatus = _useGetDailyWheelData.status;

  var _useLazyGetDailyWheel = useLazyGetDailyWheelBonusQuery(),
      _useLazyGetDailyWheel2 = _slicedToArray(_useLazyGetDailyWheel, 2),
      claimBonus = _useLazyGetDailyWheel2[0],
      isLoading = _useLazyGetDailyWheel2[1].isLoading;

  var _useSelector = useSelector(function (state) {
    return {
      casinoIdStatus: state.playerInfo.casinoIdStatus,
      actionCommands: state.actionCommands.actions.find(function (action) {
        var _action$payload;

        return (action === null || action === void 0 ? void 0 : (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.screen) === screens.Home;
      }),
      modal: state.modal.modal,
      dailyWheelAssets: state.assetsPackage.assets.DAILY_WHEEL
    };
  }, shallowEqual),
      casinoIdStatus = _useSelector.casinoIdStatus,
      modal = _useSelector.modal,
      actionCommands = _useSelector.actionCommands,
      dailyWheelAssets = _useSelector.dailyWheelAssets;

  var _useWheelLogHandler = useWheelLogHandler(),
      claimLogHandler = _useWheelLogHandler.claimLogHandler;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      step = _useState2[0],
      changeStep = _useState2[1];

  var skipDailyWheel = function skipDailyWheel() {
    var _actionCommands$modal, _actionCommands$modal2, _actionCommands$modal3, _actionCommands$modal4, _actionCommands$modal5, _actionCommands$modal6, _actionCommands$modal7, _actionCommands$paylo;

    if (modal === screens.DailySpin) dismissModal();
    Emitter.emit(EVENT_EMITTER_TYPE.ACTION_COMMANDS, {
      actionType: ACTION_COMMANDS_TYPE.NOTIFY_TRIGGER_PROCESSED_REQUEST,
      data: {
        event: ACTION_COMMANDS_EVENT_TYPE.ACCEPT_APP_MODAL,
        modalType: actionCommands === null || actionCommands === void 0 ? void 0 : (_actionCommands$modal = actionCommands.modal) === null || _actionCommands$modal === void 0 ? void 0 : _actionCommands$modal.modalType,
        triggerExecution: actionCommands === null || actionCommands === void 0 ? void 0 : (_actionCommands$modal2 = actionCommands.modal) === null || _actionCommands$modal2 === void 0 ? void 0 : (_actionCommands$modal3 = _actionCommands$modal2.buttons[0]) === null || _actionCommands$modal3 === void 0 ? void 0 : (_actionCommands$modal4 = _actionCommands$modal3.onClickAction) === null || _actionCommands$modal4 === void 0 ? void 0 : _actionCommands$modal4.triggerExecution,
        payload: actionCommands === null || actionCommands === void 0 ? void 0 : (_actionCommands$modal5 = actionCommands.modal) === null || _actionCommands$modal5 === void 0 ? void 0 : (_actionCommands$modal6 = _actionCommands$modal5.buttons[0]) === null || _actionCommands$modal6 === void 0 ? void 0 : (_actionCommands$modal7 = _actionCommands$modal6.onClickAction) === null || _actionCommands$modal7 === void 0 ? void 0 : _actionCommands$modal7.payload,
        isFtueFlow: (actionCommands === null || actionCommands === void 0 ? void 0 : (_actionCommands$paylo = actionCommands.payload) === null || _actionCommands$paylo === void 0 ? void 0 : _actionCommands$paylo.featureGroup) === ACTION_COMMANDS_FEATURE_GROUP.FTUE
      }
    });
  };

  var _ref2 = dailyWheelData !== null && dailyWheelData !== void 0 ? dailyWheelData : defaultBonusData,
      bonusInfo = _ref2.bonusInfo,
      totalLoyalty = _ref2.totalLoyalty,
      totalCoinsAfterTierBonus = _ref2.totalCoinsAfterTierBonus;

  var claimDailyBonus = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var isSkipped,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isSkipped = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
              audio.onClick();
              audio.playCoinSfx();
              claimBonus({
                forceRefetch: true
              }).unwrap().then(function (response) {
                if (response[0]) claimLogHandler(response[0], bonusInfo, totalLoyalty, totalCoinsAfterTierBonus, isSkipped);
                skipDailyWheel();
              }).catch(function () {
                return skipDailyWheel();
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function claimDailyBonus() {
      return _ref3.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (isError || !dailyWheelAssets || dailyWheelDataStatus === REQUEST_QUERY_STATUS.FULFILLED && !dailyWheelData) skipDailyWheel(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError, dailyWheelAssets, dailyWheelDataStatus]);
  useEffect(function () {
    return function () {
      audio.fadeOut('crowdsTalking');
      audio.playMusic('backgroundMusic');
      Emitter.emit(EVENT_EMITTER_TYPE.ACTION_COMMANDS, {
        actionType: ACTION_COMMANDS_TYPE.CLEAR_ACTION_COMMAND
      });
    };
  }, []);
  return _objectSpread(_objectSpread(_objectSpread({}, dailyWheelData !== null && dailyWheelData !== void 0 ? dailyWheelData : defaultBonusData), getLoginStreakList(bonusInfo)), {}, {
    claimDailyBonus: claimDailyBonus,
    step: step,
    changeStep: changeStep,
    isPhysicallyVerified: casinoIdStatus === PlayerStatus.PHYSICALLY_VERIFIED,
    linkedAccount: (bonusInfo === null || bonusInfo === void 0 ? void 0 : bonusInfo.CURRENT_MEMBER_TIER) !== 'Unlinked',
    isLoading: isLoading,
    dailyWheelAssets: dailyWheelAssets
  });
}
var defaultBonusData = {
  bonusInfo: false,
  currentTierBonus: null,
  wheelBonus: 0,
  dailyBonus: 0,
  totalLoyalty: 0,
  totalCoinsAfterTierBonus: 1,
  spinnerItems: [],
  showTotalLoyalty: false,
  showTotalCoins: false
};